import { render, staticRenderFns } from "./CreatedAlert.vue?vue&type=template&id=66f22e36"
import script from "./CreatedAlert.vue?vue&type=script&lang=js"
export * from "./CreatedAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports